import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DashboardPerScopeValueRequest, DashboardPerScopeValueResponse } from '@api/domain/types';
import type { AppDispatch, RootState } from '@store/types';
import { backendCall, createApiCall } from '@reducers/utils';

interface FetchDashboardPerScopeValueBestArgs {
  params: DashboardPerScopeValueRequest;
  signal?: AbortSignal;
}

export const fetchDashboardPerScopeValueBest = createAsyncThunk<
  DashboardPerScopeValueResponse | undefined,
  FetchDashboardPerScopeValueBestArgs,
  { state: RootState; dispatch: AppDispatch }
>('dashboard/fetchDashboardPerScopeValueBest', async ({ params, signal }, { dispatch }) => {
  return await dispatch(
    backendCall(
      createApiCall((api) => api.dashboard.getDashboardPerScopeValue, {
        params,
        signal,
      })
    )
  );
});
